import React, {Component} from "react";
import tos from "./tos.txt"

export default class Footer extends Component {
    render() {
        return <div className={"footer"}>
            <a href={tos}>Terms of Service</a> | <span>© 2026 Corvino Labs LLC</span>
        </div>
    }
}
